import { IGraphQlConnection } from 'types/core.types';

export const removeGraphConnections = <T, S = undefined>(graph: IGraphQlConnection<T, S>): T[] => {
  return graph.edges.map(({ node }) => node);
};

export const buildGraphConnections = <T>(collection: Array<T>): IGraphQlConnection<T> => {
  return {
    edges: collection.map(activity => {
      return {
        node: activity,
      };
    }),
  };
};
